<template>
  <div
    class="gift-card-preview"
    @click="handleClick"
    :class="{ disabled: !clickable }"
    :style="{ backgroundImage: backgroundImageUrl }"
  >
    <div class="card-header">
      <span class="card-label">Gift Card</span>
      <div class="card-price">
        <span class="price-label">Price</span>
        <span class="price-value">${{ formatPrice(cardData.price) }}</span>
      </div>
    </div>
    <div class="card-name">{{ cardData.name || 'Gift Card' }}</div>
    <div class="card-scope">{{ scopeText }}</div>
    <div class="card-footer">
      <div class="shop-info">
        <img :src="supplierLogo" alt="" class="shop-logo" />
        <span class="shop-name">{{ supplierName }}</span>
      </div>
      <div class="card-value">
        <span class="value-label">Value</span>
        <span class="value-amount">${{ formatPrice(cardData.value) }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GiftCardPreview',
  props: {
    cardData: {
      type: Object,
      default: () => ({})
    },
    clickable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    supplierName() {
      if (this.cardData.supplier && this.cardData.supplier.name) {
        return this.cardData.supplier.name
      }
      return 'Merchant'
    },
    supplierLogo() {
      const supplier = this.cardData.supplier
      const logo = supplier && supplier.logo && supplier.logo.file_path
      return this.formatImagePath(logo) || 'https://pic.rmb.bdstatic.com/bjh/bc11504608c0/250314/7904a9d0b5755cec95a4bb00d8763f94.png'
    },
    backgroundImageUrl() {
      const cardImage = this.cardData.card_image
      if (cardImage) {
        const url = this.formatImagePath(cardImage)
        return url ? `url(${url})` : 'linear-gradient(135deg, #1a4d3e 0%, #2d6b5a 50%, #1a4d3e 100%)'
      }
      return 'linear-gradient(135deg, #1a4d3e 0%, #2d6b5a 50%, #1a4d3e 100%)'
    },
    scopeText() {
      const scope = Number(this.cardData.applicable_scope)
      if (scope === 0) return 'All Services & Products'
      if (scope === 1) return 'Selected Services Only'
      return 'See Merchant Details'
    }
  },
  methods: {
    formatPrice(value) {
      const num = Number(value || 0)
      return num.toFixed(2)
    },
    formatImagePath(path) {
      if (!path) return ''
      let finalPath = path.trim()
      if (/^https?:/i.test(finalPath)) {
        return finalPath.replace('http://localhost:8080', 'http://www.hwm.red')
      }
      finalPath = finalPath.replace(/^\/+/, '')
      // 相对路径需要加上 /uploads/ 前缀（参考网页端的 resolveUploadUrl）
      const fullPath = finalPath.startsWith('uploads/') ? `/${finalPath}` : `/uploads/${finalPath}`
      return `http://www.hwm.red${fullPath}`
    },
    handleClick() {
      if (!this.clickable) return
      this.$router.push({
        path: '/giftCardDetail',
        query: {
          card_id: this.cardData.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.gift-card-preview {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 12px;
  padding: 1.25rem;
  box-sizing: border-box;
  color: #fff;
  position: relative;
  overflow: hidden;
  margin-bottom: 1rem;
  cursor: pointer;
  &.disabled {
    cursor: default;
  }
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 30%;
    width: 150px;
    height: 150px;
    background: radial-gradient(circle, rgba(100, 180, 140, 0.35) 0%, transparent 70%);
    transform: translate(-50%, -50%);
    pointer-events: none;
  }
  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 1rem;
    position: relative;
    z-index: 1;
    .card-label {
      font-size: 0.875rem;
      color: rgba(255, 255, 255, 0.8);
    }
    .card-price {
      text-align: right;
      .price-label {
        display: block;
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 2px;
      }
      .price-value {
        font-size: 1.25rem;
        font-weight: 700;
      }
    }
  }
  .card-name {
    font-size: 1.25rem;
    font-weight: 600;
    margin-bottom: 4px;
    position: relative;
    z-index: 1;
  }
  .card-scope {
    font-size: 0.75rem;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 1rem;
    position: relative;
    z-index: 1;
  }
  .card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
    .shop-info {
      display: flex;
      align-items: center;
      gap: 8px;
      .shop-logo {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        object-fit: cover;
        background: #f0f0f0;
      }
      .shop-name {
        font-size: 0.875rem;
        color: rgba(255, 255, 255, 0.9);
      }
    }
    .card-value {
      text-align: right;
      .value-label {
        display: block;
        font-size: 0.75rem;
        color: rgba(255, 255, 255, 0.7);
        margin-bottom: 2px;
      }
      .value-amount {
        font-size: 1.25rem;
        font-weight: 700;
      }
    }
  }
}
</style>
